import clsx from 'clsx';

import cloud1 from '@/assets/images/clouds/cloud-1.webp';
import cloud2 from '@/assets/images/clouds/cloud-2.webp';
import cloud3 from '@/assets/images/clouds/cloud-3.webp';

import styles from './Cloud.module.scss';

export interface CloudProps {
  variant?: 1 | 2 | 3;
  className?: string;
}

export function Cloud({ variant = 1, className }: CloudProps) {
  return (
    <div className={clsx(styles.cloud, className)}>
      <img src={variant === 1 ? cloud1 : variant === 2 ? cloud2 : cloud3} alt="Cloud" />
    </div>
  );
}
